import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { UploadPlanData, UploadPlansState } from 'src/types/plan.interface'

import { ADMIN } from '../../lib/api-routes'
import { instance } from '../../lib/axiosInstance'

const initialState: UploadPlansState = {
  data: null,
  error: null,
  id: null,
  isUploading: false,
}

export const uploadPlans = createAsyncThunk<UploadPlanData, FormData>(
  'adminConsole/uploadPlans',
  async (formdata: FormData) => {
    const accessToken = formdata.get('id')?.toString()
    const email = formdata.get('email')?.toString()
    const groups = formdata.get('groups')?.toString()
    const userdivision = formdata.get('userdivision')?.toString()
    const resourceUrl = `${ADMIN}/files`
    return await instance
      .post<UploadPlanData>(resourceUrl, formdata, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          'Content-Type': 'multipart/form-data',
        },
        params: {
          action: 'upload',
          email,
          groups,
          userdivision,
        },
      })
      .then((response) => response.data)
  }
)

export const adminConsole = createSlice({
  extraReducers: (builder) => {
    builder
      .addCase(uploadPlans.pending, (state) => {
        state.error = null
        state.isUploading = true
      })
      .addCase(uploadPlans.fulfilled, (state, action) => {
        state.data = action.payload
        state.error = null
        state.isUploading = false
      })
      .addCase(uploadPlans.rejected, (state, action) => {
        state.error = action.error.message ?? ''
        state.isUploading = false
      })
  },
  initialState,
  name: 'adminConsole',
  reducers: {
    resetPlanData: (state) => {
      state.data = null
      state.error = null
      state.isUploading = false
    },
  },
})

export const { resetPlanData } = adminConsole.actions
